export default "__VITE_ASSET__Bt3hRnY2__"